// DS: i8.1 Hidden, System Messages / i8.1 Hidden
import React from 'react';
import IconWrap from '../../IconWrap';
const Hidden = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m5.95 4.13 3.8 3.8A11.65 11.65 0 0 1 16 6c4.26 0 8.18 2.56 11.86 7.35l.34.45.54.74c.32.42.35.99.1 1.44l-.1.15-.54.73a25.73 25.73 0 0 1-4.61 4.91l4.28 4.28a1 1 0 0 1-1.42 1.41l-4.53-4.53A11.33 11.33 0 0 1 16 24.67c-4.26 0-8.18-2.56-11.86-7.35l-.34-.46-.54-.73a1.33 1.33 0 0 1-.1-1.44l.1-.15.54-.74a26.29 26.29 0 0 1 4.32-4.67L4.53 5.54a1 1 0 1 1 1.42-1.41Zm-.27 10.5-.52.7.24.33.33.44c3.4 4.44 6.8 6.57 10.27 6.57 1.5 0 2.98-.4 4.46-1.2L18.6 19.6a5 5 0 0 1-6.87-6.87l-2.19-2.19a23.35 23.35 0 0 0-3.86 4.09ZM11.2 9.4A9.34 9.34 0 0 1 16 8c3.48 0 6.87 2.13 10.27 6.56l.33.45.24.32-.52.7a22.71 22.71 0 0 1-4.16 4.32l-2.1-2.1a5 5 0 0 0-6.98-6.98l-1.87-1.88Z"
    })));
};
Hidden.displayName = 'Hidden';
export default Hidden;
